export const APP_KEY = 'kid_r18H3Lf4Y';
export const APP_SECRET = '6d569d0325e7457da424829a3fc66130';
